import { useState, useEffect } from 'react';
import RelationshipTile from './RelationshipTile';
import { MenuItem } from '@mui/material';
import { TextFieldRow, TextField } from 'components';
import style from '../contributor.module.css';

const RelationshipType = (props) => {
	const { selected, label, textFieldLabel, menuList, handleMenuSelect } = props;

	const [selectedObject, setSelectedObject] = useState({});
	const [selectedValue, setSelectedValue] = useState('');

	useEffect(() => {
		const isInList = menuList.some((relation) => relation.label === selected);

		if (isInList) {
			let result = menuList.filter((val) => {
				return val.label === selected;
			});
			setSelectedObject(result[0]);
			setSelectedValue(selected);
		} else if (selected) {
			let result = { label: selected, value: selected };
			setSelectedValue('Other');
			setSelectedObject(result);
		} else {
			setSelectedValue('');
			setSelectedObject({});
		}
	}, [selected, menuList]);

	const tile = Boolean(selectedObject) ? (
		<>
			{selectedObject.label === 'Other' ? (
				<TextFieldRow
					label={'Relation Type'}
					key={'contrib-relation-type'}
					variant='outlined'
					value={props.customValue}
					onChange={props.changeCustomValue}
					required={true}
				/>
			) : (
				<RelationshipTile value={selectedObject}>
					{selectedObject.label}
				</RelationshipTile>
			)}
		</>
	) : null;

	const menuSelect = (e, value) => {
		handleMenuSelect(e, value);
	};
	const id = label?.toLowerCase().replace(/ /g, '-') + '-single-selector-';

	return (
		<div className={style.selectorListRoot} id={id + 'root'}>
			{menuList.length > 0 ? (
				<TextField
					select
					disabled={props.disabled}
					id={id + 'textField'}
					SelectProps={{ multiple: false }}
					className={style.selectorListTextField}
					value={selectedValue || ''}
					variant='outlined'
					required={true}
					label={textFieldLabel || ''}
					onChange={menuSelect}>
					{menuList.map((val, i) => (
						<MenuItem key={`${val.id}-${i}`} value={val.value}>
							{val.label}
						</MenuItem>
					))}
				</TextField>
			) : null}
			<div>{tile}</div>
		</div>
	);
};

export default RelationshipType;
